import { Loading } from 'components/index.js'
import Drawer from 'react-bottom-drawer'

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NewsContent from './NewsContent'
import { bookmarkNews, fetchNewsById, likeDislikeNews, updateNewsCount } from 'store/actions/news.action'
import { useMediaQuery } from 'react-responsive'
import { useRouter } from 'next/router'
import { Dialog, DialogContent } from '@components/ui/dialog'

const DetailedNewsModel = ({ id, setIsNewsModalOpen }) => {
  const isMobile = useMediaQuery({ maxWidth: 600 })
  const dispatch = useDispatch()
  const router = useRouter()

  const [selectedNews, setSelectedNews] = useState(null)
  let { filteredNewsData } = useSelector((state) => state.news)
  const { user } = useSelector((state) => state.auth)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [isLiked, setIsLiked] = useState(false)
  const [totalLikes, setTotalLikes] = useState(0)

  const [isBookmarked, setIsBookmarked] = useState(false)
  const [totalBookmarks, setTotalBookmarks] = useState(0)

  const [currentIndex, setCurrentIndex] = useState(() => {
    return filteredNewsData.findIndex((news) => news.news_id === id) || 0
  })

  const handleNextButtonClick = () => {
    const nextNewsIndex = (currentIndex || 0) + 1
    if (nextNewsIndex < filteredNewsData?.length) {
      setCurrentIndex(nextNewsIndex)
    }
  }

  const handlePrevButtonClick = () => {
    if (currentIndex > 0) {
      const nextNewsIndex = currentIndex - 1
      if (nextNewsIndex < filteredNewsData?.length) {
        setCurrentIndex(nextNewsIndex)
      }
    }
  }

  const handleKeyDown = (e) => {
    if (e.keyCode == 37) {
      handlePrevButtonClick()
    } else if (e.keyCode == 39) {
      handleNextButtonClick()
    } else if (e.keyCode == 27) {
      handleNewModalClose()
    }
  }

  useEffect(() => {
    if (currentIndex >= 0) {
      const data = filteredNewsData && filteredNewsData[currentIndex]
      if (data?.news_id) {
        router.push({ pathname: `/`, query: { ...router.query, id: data?.news_id } }, undefined, { shallow: true })
      }
    }
  }, [currentIndex])

  const handleNewModalClose = () => {
    router.push({ pathname: `/`, query: { tab: 'news' } }, undefined, { shallow: true })
    setIsNewsModalOpen(false)
  }

  const handleBookmark = () => {
    const newIsBookmarked = !isBookmarked
    setIsBookmarked(newIsBookmarked)
    setTotalBookmarks((prev) => Math.max(0, prev + (newIsBookmarked ? 1 : -1)))
    dispatch(bookmarkNews(selectedNews?.news_id, user?.id, isBookmarked, setIsBookmarked, setTotalBookmarks))
  }

  const handleNewsLike = () => {
    const newIsLiked = !isLiked
    setIsLiked(newIsLiked)
    setTotalLikes((prev) => Math.max(0, prev + (newIsLiked ? 1 : -1)))
    dispatch(likeDislikeNews(selectedNews?.news_id, user?.id, isLiked, setIsLiked, setTotalLikes))
  }

  useEffect(() => {
    if (id && !loading) {
      dispatch(
        fetchNewsById(
          id,
          setSelectedNews,
          setLoading,
          setError,
          setTotalLikes,
          user?.id,
          setIsLiked,
          setIsBookmarked,
          setTotalBookmarks
        )
      )
      dispatch(updateNewsCount(id))
    } else {
      handleNewModalClose()
    }
  }, [id])

  useEffect(() => {
    if (error && !loading) {
      handleNewModalClose()
    }
  }, [error])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [currentIndex])

  return (
    <>
      {loading && !error && <Loading />}
      {!isMobile && selectedNews && (
        <Dialog open={true} onOpenChange={handleNewModalClose}>
          <DialogContent className=" !max-h-[95vh] overflow-auto min-w-max">
            <div key={selectedNews} className=" w-full ">
              <NewsContent
                id={id}
                selectedNews={selectedNews}
                setSelectedNews={setSelectedNews}
                currentIndex={currentIndex}
                filteredNewsData={filteredNewsData}
                handleNextButtonClick={handleNextButtonClick}
                handlePrevButtonClick={handlePrevButtonClick}
                handleNewsLike={handleNewsLike}
                handleBookmark={handleBookmark}
                isLiked={isLiked}
                isBookmarked={isBookmarked}
                totalLikes={totalLikes}
                totalBookmarks={totalBookmarks}
                handleKeyDown={handleKeyDown}
              />
            </div>
          </DialogContent>
        </Dialog>
      )}
      {isMobile && selectedNews && (
        <Drawer
          isVisible={id}
          onClose={handleNewModalClose}
          className="newsfilter-drawer overflow-x-visible  newsDrawer"
        >
          <div className={`cursor-pointer absolute top-2 right-5 z-[99]`} onClick={handleNewModalClose}>
            <img src={'/assets/common/close.svg'} width={20} height={20} alt="close" />
          </div>
          <NewsContent
            id={id}
            selectedNews={selectedNews}
            setSelectedNews={setSelectedNews}
            currentIndex={currentIndex}
            filteredNewsData={filteredNewsData}
            handleNextButtonClick={handleNextButtonClick}
            handlePrevButtonClick={handlePrevButtonClick}
            handleNewsLike={handleNewsLike}
            handleBookmark={handleBookmark}
            isLiked={isLiked}
            isBookmarked={isBookmarked}
            totalLikes={totalLikes}
            totalBookmarks={totalBookmarks}
          />
        </Drawer>
      )}
    </>
  )
}

export default DetailedNewsModel
